import { useLocation } from '@tanstack/react-router';
import { useEffect } from 'react';
import mixpanel from 'src/shared/lib/mixpanel';

export default function RouteAnalytics() {
  const { pathname } = useLocation();

  useEffect(() => {
    try {
      mixpanel.track('Navigation', {
        path: pathname,
        full: window.location.href,
        url: window.origin + pathname,
      });
    } catch (error) {
      console.error(error);
    }
  }, [pathname]);

  return null;
}
